import { PERMISSIONS_HIERARCHY } from '../constants/general-constants';
import { AccessTypeEnum, PermissionAccessZoneEnum } from '../interfaces/permissions.interface';
import { InternalPermissions } from '../interfaces/current-supplier-user.interface';

export function supplierUserHasAccess(
    supplierUserInternalPermissions: InternalPermissions[] | undefined,
    accessNameToCheck: PermissionAccessZoneEnum,
    minLevel: AccessTypeEnum,
): boolean {
    if (!supplierUserInternalPermissions || !supplierUserInternalPermissions.length) {
        return false;
    }
    const supplierUserAccess = supplierUserInternalPermissions?.find(
        (x) => x?.permissionAccessZone?.toLowerCase() === accessNameToCheck.toLocaleLowerCase(),
    );
    if (!supplierUserAccess || !supplierUserAccess.accessType) {
        return false;
    }

    const permissionHierarchyToCompare = PERMISSIONS_HIERARCHY.map((x) => x.toLowerCase());
    const supplierUserLevelToCompare = supplierUserAccess.accessType.toLocaleLowerCase();
    const minLevelToCompare = minLevel.toLocaleLowerCase();
    return permissionHierarchyToCompare.indexOf(minLevelToCompare) <= permissionHierarchyToCompare.indexOf(supplierUserLevelToCompare);
}
